"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ChevronRight = _interopRequireDefault(require("elevate-ui-icons/ChevronRight"));

var _BaseAccordion = _interopRequireDefault(require("./BaseAccordion"));

var _AccordionContents = _interopRequireDefault(require("./AccordionContents"));

var _Paper = _interopRequireDefault(require("../Paper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Accordion =
/*#__PURE__*/
function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    _classCallCheck(this, Accordion);

    return _possibleConstructorReturn(this, _getPrototypeOf(Accordion).apply(this, arguments));
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          items = _this$props.items,
          openIndexes = _this$props.openIndexes,
          rest = _objectWithoutProperties(_this$props, ["classes", "items", "openIndexes"]);

      return _react["default"].createElement(_BaseAccordion["default"], _extends({}, rest, {
        openIndexes: openIndexes
      }), function (_ref) {
        var openIndexes = _ref.openIndexes,
            handleItemClick = _ref.handleItemClick;
        return _react["default"].createElement(_Paper["default"], _extends({}, rest, {
          withPadding: false
        }), items.map(function (item, index) {
          var _classNames;

          return _react["default"].createElement("div", {
            // AccordionItem
            key: index,
            className: classes.item
          }, _react["default"].createElement("button", {
            // AccordionButton
            className: classes.button,
            type: "button",
            onClick: function onClick() {
              return handleItemClick(index);
            }
          }, _react["default"].createElement("span", {
            className: classes.headerTitle
          }, item.title), _react["default"].createElement("div", {
            className: classes.headerIcon
          }, _react["default"].createElement(_ChevronRight["default"], {
            className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classes.chevron, true), _defineProperty(_classNames, classes.rotateMinus90, openIndexes.includes(index)), _defineProperty(_classNames, classes.rotate90, !openIndexes.includes(index)), _classNames))
          }))), _react["default"].createElement(_AccordionContents["default"], {
            className: openIndexes.includes(index) ? classes.content : null,
            isOpen: openIndexes.includes(index)
          }, item.contents));
        }));
      });
    }
  }]);

  return Accordion;
}(_react.Component);

var _default = (0, _withStyles["default"])(function (theme) {
  return {
    item: {
      display: "flex",
      flexDirection: "column",
      borderBottom: "1px solid ".concat(theme.colors["gray200"]),
      transition: theme.transitions.accordion,
      "&:last-child": {
        borderBottom: "none"
      }
    },
    button: {
      display: "flex",
      padding: "16px",
      textAlign: "left",
      alignItems: "center",
      "&:focus": {
        outline: "none"
      }
    },
    headerTitle: {
      display: "flex",
      fontWeight: "600",
      color: theme.colors.gray["600"],
      letterSpacing: ".8px",
      fontSize: "14px",
      textTransform: "uppercase"
    },
    headerIcon: {
      flexShrink: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "auto"
    },
    content: {
      display: "flex",
      flexDirection: "column",
      padding: "0px 16px 16px",
      transition: "all 2s ease-in-out"
    },
    chevron: {
      color: theme.colors.gray["500"]
    },
    rotateMinus90: {
      transform: "rotate(-90deg)",
      transition: ".2s ease"
    },
    rotate90: {
      transform: "rotate(90deg)",
      transition: ".2s ease"
    }
  };
})(Accordion);

exports["default"] = _default;